import { canonicalTimeZone, isValidTimeZone } from '@hygge/shared';

/**
 * The zone this browser is in, as an IANA name — `Europe/Kyiv`,
 * `America/New_York`.
 *
 * [HW-916] This is sent ALONGSIDE the typed date and start time, not through
 * them: the wall digits the author typed are written to `startedAt` as-is
 * (a Kyiv 09:00 stays "09:00" in storage), and this zone rides along on the
 * side so the server — and later readers — know whose clock those digits
 * are. Nothing here converts an instant through it. Read from the runtime on
 * every call rather than once, because a laptop that flies changes its zone
 * without reloading the tab.
 *
 * UTC only when the runtime cannot name its zone at all, which no supported
 * browser does; the fallback exists so a write never goes out without one.
 */
export function viewerTimeZone(): string {
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // Canonical spelling: Chrome says `Europe/Kiev`, the rows say `Europe/Kyiv`.
    return zone && isValidTimeZone(zone) ? canonicalTimeZone(zone) : 'UTC';
  } catch {
    return 'UTC';
  }
}
